import { Link } from 'react-router-dom';
import type { Anime } from '@/types';

interface AnimeCardProps {
  anime: Anime;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title}封面图`}
          title={`${anime.title} - 妖精动漫`}
          className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-xs">
          {anime.region}
        </span>
        {anime.rating > 0 && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold flex items-center gap-1">
            <i className="ri-star-fill text-[10px]"></i>
            {anime.rating.toFixed(1)}
          </span>
        )}
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
          {anime.status}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {anime.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed min-h-[2rem]">
          {anime.summary}
        </p>
        <div className="flex flex-wrap gap-1.5 pt-0.5">
          <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
            {anime.type}
          </span>
          <span className="px-2 py-0.5 rounded-md bg-background-100 text-foreground-600 text-xs">
            {anime.year}
          </span>
        </div>
      </div>
    </Link>
  );
}